import { getParentFlatName } from './getParentFlatName';

const toNameTemplate = (flatName: string) => flatName.replace(/\[(.+?)\]/g, '[i]');

/**
 * Поднимается по пути поля, пока не найдёт запись в карте полей паспорта:
 * `requirementsNpaErknm[0].mandatory[1].id` -> ... -> `requirementsNpaErknm[0].mandatory`.
 *
 * Нужно потому, что валидатор кладёт ошибку на лист, а заголовок и якорь для скролла
 * заведены только у блока целиком. Без этого шага в панели ошибок появились бы
 * пустые строки (title === undefined).
 */
export const getNearestKnownFlatName = (flatName: string, fieldsDataByFlatNameMap: object): string | undefined => {
  const map = fieldsDataByFlatNameMap as Record<string, unknown>;
  let path = flatName;

  while (path) {
    if (map[toNameTemplate(path)]) return path;

    path = getParentFlatName(path);
  }

  return undefined;
};
